import { core } from "@angular/compiler";

export const api = {
  v1: {
    users: 'v1/users',
    grants: `v1/grants`,
    countries: 'v1/countries',
    businessUnits: 'v1/business-units',
    regions: 'v1/regions',
    locationVersions: 'v1/location-versions',
    roles: 'v1/roles',
    permissions: 'v1/permissions',
    expenditureCategories: 'v1/types/expenditure-categories',
    labels: 'v1/types/budget-labels',
    lineItemTypes: 'v1/types/line-item-types',
    coreBaseBuild: 'v1/types/core-base-build',
    types: {
      wellStatuses: 'v1/types/well-statuses',
      accountingStatuses: 'v1/types/accounting-statuses',
      leadershipTrackingStatuses: 'v1/types/leadership-tracking-statuses',
      hydroCarbonTypes: 'v1/types/hydro-carbon-types',
      captureTypes: 'v1/types/capture-types',
      surveyTypes: 'v1/types/survey-types',
      explorationTypes: 'v1/types/exploration-types',
    },
    businessPlan: {
      businessPlan: 'v1/business-plans',
      lineItems: 'v1/business-plan/line-items',
      wells: 'v1/business-plan/wells',
      summary: 'v1/business-plan/summaries',
    },
    monthlyTracking: {
      lineItems: 'v1/monthly-tracking/line-items',
      actuals: 'v1/monthly-tracking/actuals',
      outlooks: 'v1/monthly-tracking/outlooks',
      yearout: 'v1/monthly-tracking/year-outs',
      forecasts: 'v1/monthly-tracking/forecasts',
      categorized_line_items: 'v1/monthly-tracking/categorized-line-items',
      leadership_tracking: 'v1/monthly-tracking/leadership-tracking',
      wells: 'v1/monthly-tracking/wells',
      summary: 'v1/monthly-tracking/summaries' 
    }
  }
}
